function ContactThanks()
{
    return <div className="contactThanks">
        <img src={'/media/images/icons/mail.png'} alt={'icon'}/>
        <h1>Message Received!</h1>
        <p>Thanks for getting in touch! You'll get a reply as soon as possible.</p>
    </div>
}

export default ContactThanks;